import LinkOut from './LinkOut';

export default LinkOut;
